export const colorsUtils = {
    setRgbaAlpha: (color: string, alpha: number) => {
        // color might be in the format "rgba(131, 56, 236, 1)" or rgb(131, 56, 236)
        let [r, g, b, a] = color.split(',')

        // r value might be in the format "rgba(131" or "rgb(131"
        r = r.replace('rgba(', '').replace('rgb(', '')
        a = alpha.toString()
        return `rgba(${r}, ${g}, ${b}, ${a})`
    },

    /**
    * 
    * @param hexColor 
    * @returns bool - true if the color is light, false if the color is dark
    */
    getContrastColor: (hexColor: string): boolean => {
        // If the color is not in the correct format or not provided, return black as default.
        if (!hexColor || hexColor.length !== 7 || hexColor[0] !== '#') {
            return false;
        }

        const r = parseInt(hexColor.substr(1, 2), 16);
        const g = parseInt(hexColor.substr(3, 2), 16);
        const b = parseInt(hexColor.substr(5, 2), 16);

        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

        return luminance > 0.5
    },

    getColor: (index: number): string => {
        return colorsUtils.colors[index % colorsUtils.colors.length];
    },

    /** Stable color assignment per name — sequential, no collisions, consistent within session */
    _nameColorMap: new Map<string, string>(),
    _nextColorIndex: 0,
    getColorForName: (name: string): string => {
        const existing = colorsUtils._nameColorMap.get(name)
        if (existing) return existing
        const color = colorsUtils.hexColors[colorsUtils._nextColorIndex % colorsUtils.hexColors.length]
        colorsUtils._nextColorIndex++
        colorsUtils._nameColorMap.set(name, color)
        return color
    },

    /**
     * Hex palette — ordered for maximum contrast between neighbours.
     * Alternates warm/cool and light/dark so adjacent segments
     * in a doughnut or bar chart are always distinguishable.
     */
    hexColors: [
        '#06C8FF', // cyan (brand)
        '#E3211C', // red
        '#10B981', // emerald
        '#A500FF', // violet
        '#FF9E1C', // orange
        '#3B82F6', // blue
        '#EC4899', // pink
        '#22C55E', // green
        '#8B5CF6', // purple
        '#F59E0B', // amber
        '#14B8A6', // teal
        '#E11D48', // rose
        '#84CC16', // lime
        '#6366F1', // indigo
        '#F97316', // orange alt
        '#0EA5E9', // sky
        '#D946EF', // fuchsia
        '#059669', // emerald alt
        '#EAB308', // yellow
        '#7C3AED', // violet alt
        '#0891B2', // cyan alt
        '#F43F5E', // rose alt
        '#35AAD5', // cyan soft
        '#EA580C', // orange dark
        '#4F46E5', // indigo alt
    ],

    colors: [
        "rgba(99, 102, 241, 1)",   // Indigo moderne
        "rgba(16, 185, 129, 1)",   // Emerald
        "rgba(245, 101, 101, 1)",  // Red coral
        "rgba(251, 191, 36, 1)",   // Amber
        "rgba(139, 92, 246, 1)",   // Violet
        "rgba(6, 182, 212, 1)",    // Cyan
        "rgba(236, 72, 153, 1)",   // Pink
        "rgba(34, 197, 94, 1)",    // Green
        "rgba(249, 115, 22, 1)",   // Orange
        "rgba(168, 85, 247, 1)",   // Purple
        "rgba(14, 165, 233, 1)",   // Sky blue
        "rgba(244, 63, 94, 1)",    // Rose
        "rgba(132, 204, 22, 1)",   // Lime
        "rgba(234, 88, 12, 1)",    // Orange alt
        "rgba(79, 70, 229, 1)",    // Indigo alt
        "rgba(5, 150, 105, 1)",    // Emerald alt
        "rgba(219, 39, 119, 1)",   // Pink alt
        "rgba(59, 130, 246, 1)",   // Blue
        "rgba(245, 158, 11, 1)",   // Yellow
        "rgba(147, 51, 234, 1)",   // Violet alt
    ]
}